<template>
  <b-container id="confirm">
    <template v-if="loading">
      <initialization-progress
        title="data.wait"
        message="verification.token.p"
      ></initialization-progress>
    </template>
    <template v-else>
      <template v-if="failed">
        <verification-result
          :message="message"
          :response="response"
          :action="action"
          @click="handleClick"
        ></verification-result>
      </template>
    </template>
  </b-container>
</template>

<script>
import { SETUP_FROM_DATA } from "@/store/consts";
import * as errs from "@/util/errors";
import { LONG_DESIGN_DELAY, URL_CONFIRM_USER_CLICK } from "@/globals";
import InitializationProgress from "@/components/verification/InitializationProgress";
import VerificationResult from "@/components/verification/VerificationResult";

export default {
  name: "EmailConfirmationLink",
  components: { InitializationProgress, VerificationResult },
  props: ["token"],
  data() {
    return {
      loading: false,
      failed: false,
      message: null,
      response: null,
      action: null,
    };
  },
  methods: {
    handleClick() {
      this.$router.push({ name: "sign-in" });
    },
    fail(msg, responce, hint) {
      this.message = msg;
      this.action = hint;
      this.response = responce;
      this.failed = true;
    },
  },
  mounted() {
    this.$post(
      URL_CONFIRM_USER_CLICK.format(this.token),
      {},
      true,
      true,
      LONG_DESIGN_DELAY
    )
      .then((result) => {
        // Обновим либо инициализируем экземпляр пользователя и перейдем на страницу с поздравлением
        this.$store.dispatch(SETUP_FROM_DATA, result.user);
        this.$router.push({ name: "verificationSuccess" });
      })
      .catch((e) => {
        switch (e.code) {
          case errs.CODE_ACC_USER_NOT_FOUND:
            this.fail(
              "verification.token.wrong.m",
              "",
              "verification.token.wrong.a"
            );
            break;
          case errs.CODE_ACC_ALREADY_VERIFIED:
            this.fail(
              "verification.token.already.m",
              "",
              "verification.token.already.a"
            );
            break;
          default:
            this.fail(
              "verification.token.default.m",
              "[" + e.code + "] " + e.message,
              "verification.token.default.a"
            );
            break;
        }
      });
  },
};
</script>

<style scoped>
.icon {
  min-width: 150px;
  min-height: 150px;
}
</style>